import * as React from 'react';
import View from './view';
import {ProductsPriceFilterViewBaseProps} from '../../../model';

export const ProductsPriceFilterVisuallyImpaired: React.FC<ProductsPriceFilterViewBaseProps> = (props) => {
  return <View {...props} />;
};
